import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function ChandlerPage() {
  return <LocationPageTemplate city="Chandler" cityShort="Chandler" slug="chandler" data-id="element-1013" />;
}